import { SetStateAction, useEffect, useState } from 'react'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import ViewPage from '../../../Components/ViewPage'
import { TabelaConfig } from './components/tabela'
import { ContainerCalcario } from './styles'
import { FormularioCadastroCalcarioPropriedade } from './components/cadastro'
import { getPropriedade } from '../../../services/Propriedades'
import { useLogic } from '../../../context/useLogic'
import { getCalcario } from '../../../services/recomendacao/calcario'
import Tabs from '../../../Components/Tabs'
import { faMountain } from '@fortawesome/free-solid-svg-icons'
import { Render } from '../../../Components/CustomUi/render'

import { errorAlert } from '../../../utils/alert'
import { usePostCadastroCalcarioPropriedade } from '../../../services/cadastroCalcarioPropriedade/POST'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'

const CadastroCalcarioPropriedade: React.FC = () => {
  const { codCliente } = useLogic()
  //TABELA
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [open, setOpen] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingEditar, setEditarLoading] = useState(true)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [buscar_tabela, setBuscar_tabela] = useState<string>('')
  const [propriedade_selecionada_tabela, setPropriedade_selecionada_tabela] = useState<string>('')
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [total, setTotal] = useState(0)

  //FORMULARIO
  const [data_propriedades, setData_propriedades] = useState([])
  const [data_calcario, setData_calcario] = useState([])
  const [propriedade_selecionada, setPropriedade_selecionada] = useState<string>('')
  const [propriedade_selecionada_id, setPropriedade_selecionada_id] = useState<number>(0)
  const [calcario_selecionado, setCalcario_selecionado] = useState<string>('')
  const [calcario_selecionado_id, setCalcario_selecionado_id] = useState<number>(0)
  const [calcario_selecionados, setCalcario_selecionados] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [tab_container_atual, setTab_container_atual] = useState('Calcário por propriedade')
  const [calcario_original_id, setCalcario_original_id] = useState<number>(null)

  //API
  const { carregando_salvar_calcarioPropriedade, mutate_calcarioPropriedade } =
    usePostCadastroCalcarioPropriedade()

  const listarPropriedades = async (cod) => {
    setLoading(true)
    const response = await getPropriedade(
      cod,
      'calcario_propriedade',
      codCliente,
      '',
      '',
      buscar_tabela,
      page,
      pagination
    )
    const dados = response.data.itens
    setData_propriedades(dados.filter((item) => item?.status === 1))

    // setCalcario_original(
    //   //@ts-ignore
    //   dados.filter((item) => item?.status === 1).flatMap((item) => item?.calcarios)
    // )
    setTotal(response.data.total)
    setTimeout(() => {
      setLoading(false)
    }, 500)
  }

  const listCalcario = async () => {
    setLoading(true)
    const resp = await getCalcario({})

    setData_calcario(resp.data.itens)

    setLoading(false)
  }

  function editarCadastro(cod) {
    const editarFiltrado = (data_propriedades ?? []).filter((item) => item?.cod === cod)
    const calcarios = (editarFiltrado?.[0]?.calcarios ?? []).map((item) => {
      return { descr: item?.calcario_nome, id: item?.cod_calcario, key: item?.cod_calcario }
    })
    const calcarioPrincipal = editarFiltrado[0]?.calcarios?.filter((item) => item?.padrao === true)
    setCalcario_selecionados(calcarios)
    setCalcario_selecionado(calcarioPrincipal?.[0]?.calcario_nome)
    setCalcario_selecionado_id(calcarioPrincipal?.[0]?.cod_calcario)
    setCalcario_original_id(calcarioPrincipal?.[0]?.cod_calcario)
    setPropriedade_selecionada(editarFiltrado?.[0]?.nome)
    setPropriedade_selecionada_id(editarFiltrado?.[0]?.cod)
    setOpen(true)
  }

  function fecharGaveta() {
    setOpen(false)
    setPropriedade_selecionada('')
    setPropriedade_selecionada_id(0)
    setPropriedade_selecionada_tabela('')
    setCalcario_selecionado('')
    setCalcario_selecionado_id(0)
    setCalcario_selecionados([])
    listarPropriedades('')
  }

  function cadastrarCalcarioPropriedade() {
    const propriedadeObj = (data_propriedades ?? []).find(
      (item) => item?.cod === propriedade_selecionada_id
    )
    const originalCalcarios = propriedadeObj?.calcarios ?? []

    const removidos = originalCalcarios.filter(
      (item) => !calcario_selecionados.map((c) => c.id).includes(item?.cod_calcario)
    )

    mutate_calcarioPropriedade({
      calcario_padrao: calcario_selecionado_id,
      calcarios: calcario_selecionados.map((item) => item.id),
      calcarios_remover: removidos.map((item) => item.cod_calcario),
      cod_propriedade: propriedade_selecionada_id,
      refresh: () => fecharGaveta(),
    })
  }

  useEffect(() => {
    listarPropriedades('')
    listCalcario()
  }, [])

  // useEffect(() => {
  //   const filtrado = data_cadastro_propriedade?.itens.filter(item => item?.propriedade_nome === propriedade_selecionada_tabela)
  //   console.log(filtrado)
  // }, [propriedade_selecionada_tabela])

  useEffect(() => {
    if (buscar_tabela.length > 2) {
      setTimeout(() => {
        listarPropriedades('')
      }, 700)
    }
    if (buscar_tabela === '') {
      listarPropriedades('')
    }
  }, [buscar_tabela])

  useEffect(() => {
    listarPropriedades('')
  }, [page, pagination])

  return (
    <ContainerCalcario>
      <ViewPage
        title='Configuração AP por propriedade'
        btnClick={null}
        newHide
        rotina={25}
        onPermission={setPermissions}
        hiddeTitle
        cardBodyStyle={{ padding: 15, display: 'flex', flexDirection: 'column', gap: 10 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <TitleH1>Configuração AP por propriedade</TitleH1>

        <Tabs
          tabs={[
            { descricao: 'Calcário por propriedade', icone: faMountain },
            // { descricao: 'Lista de elementos', icone: faListCheck },
          ]}
          width={260}
          trackWidth={250}
          selecionado={tab_container_atual}
          indexInicial={0}
          onChange={setTab_container_atual}
        />

        <Render condition={tab_container_atual === 'Calcário por propriedade'}>
          <TabelaConfig
            loading={loading}
            setPagination={setPagination}
            page={page}
            setPage={setPage}
            total={total}
            listar_cadastro_propriedade={data_propriedades}
            setOpen={setOpen}
            permissao={permissions}
            editarCadastro={editarCadastro}
            deletar={undefined}
            confirmar_exclusao={false}
            setConfirmar_exclusao={setConfirmar_exclusao}
            id_item_atual={id_item_atual}
            setId_item_atual={setId_item_atual}
            nome_item_atual={nome_item_atual}
            setNome_item_atual={setNome_item_atual}
            fake_loading={fake_loading}
            setFake_loading={setFake_loading}
            buscar_tabela={buscar_tabela}
            setBuscar_tabela={setBuscar_tabela}
            propriedade_selecionada={propriedade_selecionada_tabela}
            setPropriedade_selecionada={setPropriedade_selecionada_tabela}
            data_propriedades={data_propriedades}
          />
          <FormularioCadastroCalcarioPropriedade
            open={open}
            fecharGaveta={fecharGaveta}
            propriedade_selecionada={propriedade_selecionada}
            setPropriedade_selecionada={setPropriedade_selecionada}
            calcario_selecionados={calcario_selecionados}
            setCalcario_selecionados={setCalcario_selecionados}
            setPropriedade_selecionada_id={setPropriedade_selecionada_id}
            calcario_selecionado={calcario_selecionado}
            calcario_selecionado_id={calcario_selecionado_id}
            setCalcario_selecionado={setCalcario_selecionado}
            setCalcario_selecionado_id={setCalcario_selecionado_id}
            calcario_original_id={calcario_original_id}
            data_propriedades={data_propriedades}
            data_calcarios={data_calcario}
            cadastrarCalcarioPropriedade={cadastrarCalcarioPropriedade}
            loadingSalvar={carregando_salvar_calcarioPropriedade}
            permissions={permissions}
          />
        </Render>
      </ViewPage>
    </ContainerCalcario>
  )
}

export default CadastroCalcarioPropriedade
